// Story 10.1 — `cn` helper estándar de shadcn: merge tailwind classes
// resolviendo conflictos (ej. `p-2 p-4` → `p-4`).
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
